import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Search } from '@material-ui/icons';
import VariantService from '../../../../services/VariantService/VariantService';
import BotService from '../../../../services/BotService/BotService';
import config from './Config';
import './Category.css';
/**
 * @Description This function returns Category section.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Category({ step, state, setState }) {
    const { t } = useTranslation();
    const label = 'CONTENT.VARIANTS.';
    const types = ['category', 'source_app', 'destination_app'];
    const initial = useRef([[], [], []]);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(() => {
        fetchData();
        setSearch('');
    }, [step, step > 0 ? state[types[step - 1]].length : undefined]);

    const fetchData = async () => {
        let res;
        if (step === 0) {
            if (!initial.current[0] || initial.current[0].length < 1) {
                res = await BotService.getCategoryFilter();
            } else {
                setData(initial.current[0]);
            }
        } else {
            let categories = '', sources = '';
            for (const item of state.category) { categories += item.id + ','; }
            if (step === 1) {
                res = await VariantService.getVariant(categories, '', '');
            } else {
                for (const item of state.source_app) { sources += item.id + ','; }
                res = await VariantService.getVariant(categories, sources, '');
            }
        }
        if (res?.status) {
            initial.current[step] = res.data;
            setData(res.data);
        }
    };

    const handleSearch = (e) => {
        let value = e.target.value;
        setData(initial.current[step].filter(a => a.name.toLowerCase().includes(value.toLowerCase())));
        setSearch(value);
    };

    const handleClick = (item) => {
        let index = state[types[step]].findIndex(i => i.id === item.id);
        if (index < 0) {
            state[types[step]].push(item);
        }
        else if (index > -1) {
            state[types[step]].splice(index, 1);
            if (types[step] === 'category') {
                state['source_app'] = [];
                state['destination_app'] = [];
            } else if (types[step] === 'source_app') {
                state['destination_app'] = [];
            }
            state['variant'] = { first: [], second: [] };
        }
        localStorage.setItem('variant_state', JSON.stringify(state));
        setState({ ...state });
    };

    return (
        <div className="vcategory">
            <div className="vsearch">
                <Search fontSize="small" />
                <input placeholder={t(label + 'SEARCH')} value={search} onChange={handleSearch} />
            </div>
            <div className="vcategories">
                {data?.map((item, itemI) => {
                    return (
                        <button key={itemI} onClick={() => handleClick(item)}
                            className={`vcat-button${state[types[step]].find(i => i.id === item.id) ? ' vbutton-s' : ''}`}>
                            {step === 0 ? item.name : config[item.name] ? <img style={{maxHeight: '100%', maxWidth: '100%'}} src={config[item.name]} alt={item.name} /> : item.name}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
export default Category;
